export const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      backgroundColor: '#232323',
      borderRadius: 2,
      color: '#FFFFFF',
      fontSize: 14,
      fontWeight: 500,
      padding: '8px 16px',
      border: '1px solid #494949',
    },
  },
  arrow: {
    sx: {
      color: '#494949',
    },
  },
};
